<template>
  <div class="boox-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t("commonMsg.new") }}</span>
      <span v-else>{{ $t("commonMsg.edit") }}</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="120px"
          :model="boox"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item :label="$t('boox.title2')" prop="title">
            <el-input
              v-model="boox.title"
              class="fl"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('boox.version')" prop="version">
            <el-input
              v-model="boox.version"
              class="fl"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item :label="$t('boox.region')" prop="region">
            <el-radio-group v-model="boox.region">
              <el-radio label="1">国内</el-radio>
              <el-radio label="2">国外</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item :label="$t('boox.file')" prop="file">
            <div>
              <p v-if="fileName">{{ fileName }}</p>
              <div v-if="isSave">
                <el-progress
                  class="boox-upload-progress"
                  :percentage="progress"
                  color="#BF735B"
                ></el-progress>
                <span>（正在上传中,请不要退出当前界面）</span>
              </div>
            </div>
            <el-upload
              v-if="!isSave"
              action
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handleAvatarChange"
            >
              <el-button :disabled="isSave" size="small" type="primary"
                >点击上传</el-button
              >
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Loading } from "element-ui";
import OSS from "ali-oss";

export default {
  computed: {
    ...mapGetters(["buckets"])
  },
  data() {
    return {
      boox: {
        title: "",
        version: "",
        description: "",
        public: 1
      },
      isSave: false,
      progress: 0,
      fileItem: null,
      fileName: "",
      rules: {
        title: [
          {
            required: true,
            message: this.$t("update.inputTitle"),
            trigger: "blur"
          }
        ],
        version: [
          {
            required: true,
            message: this.$t("boox.inputVersion"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    handleAvatarChange(file) {
      this.fileItem = file;
      this.fileName = file.name;
    },
    getCloudFilesDetails() {
      this.$http.getCloudFilesDetails(this.$route.query.id).then(res => {
        this.boox = Object.assign({}, res.data);
        this.fileName = res.data.file.name;
      });
    },

    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit();
          } else {
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    async create() {
      if (!this.fileItem) {
        this.elMsg(this.$t("请添加文件"), "warning");
        return;
      }
      let bucket = this.buckets["onyx-static"].bucket;
      this.isSave = true;
      let fileObj = await this.uploadOss(this.fileItem, bucket, "extension");
      this.boox.file = fileObj;

      this.$http.createCloudFiles(this.boox).then(res => {
        this.elMsg(this.$t("alertMsg.addSuccess"), "success");
        this.$router.back();
      });
    },
    async edit() {
      if (this.fileItem) {
        let bucket = this.buckets["onyx-static"].bucket;
        this.isSave = true;
        let fileObj = await this.uploadOss(this.fileItem, bucket, "extension");
        this.boox.file = fileObj;
      }

      this.$http.updateCloudFiles(this.$route.query.id, this.boox).then(res => {
        this.elMsg(this.$t("alertMsg.editSuccess"), "success");
        this.$router.back();
      });
    },

    uploadOss(file, bucket, key) {
      // let randomName =
      //   this.random_string(6) +
      //   "_" +
      //   new Date().getTime() +
      //   "." +
      //   file.name.split(".").pop();
      return new Promise(async (resolve, reject) => {
        try {
          let sts = await this.$http.aliyunSts();
          let region = this.buckets["onyx-static"].region;
          let client = await new OSS({
            region,
            accessKeyId: sts.data.AccessKeyId,
            accessKeySecret: sts.data.AccessKeySecret,
            stsToken: sts.data.SecurityToken,
            bucket,
            secure: true
          });
          let coverData = await client.multipartUpload(
            `${key}/${file.name}`,
            file.raw,
            {
              progress: (p, cpt, res) => {
                this.progress = Number((p * 100).toFixed(2));
              }
            }
          );

          resolve({
            key: coverData.name,
            bucket,
            name: file.name,
            url: coverData.res.requestUrls[0].split("?")[0]
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    random_string(len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    }
  },
  mounted() {
    if (!this.$route.query.id) return;
    this.getCloudFilesDetails();
  }
};
</script>

<style lang="scss">
.boox-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .boox-import-btn {
        margin-top: 10px;
      }
      .boox-upload-progress {
        display: flex;
        align-items: center;
        > .el-progress__text {
          /* width: 100px; */
        }
      }
    }
  }
  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label,
  .el-form-item--small .el-form-item__content {
    line-height: 24px;
  }
  .ql-editor {
    height: 450px;
  }
}
</style>
